import React, { useEffect, useState } from "react";
import { IoMdSearch } from "react-icons/io";
import { AiFillCloseCircle } from "react-icons/ai";
import { Link } from "react-router-dom";
import { useDebounce } from "use-debounce";

import { userSearch } from "../api";
import { getMediaUrl, SEARCH_DEBOUNCE } from "../lib/utils";

const UserSearch = ({ searchToggle, setSearchToggle }) => {
  const [search, setSearch] = useState("");
  const [result, setResult] = useState([]);
  const [debouncedSearch] = useDebounce(search, SEARCH_DEBOUNCE);

  useEffect(() => {
    const query = debouncedSearch.trim();

    if (!query) {
      setResult([]);
      return;
    }

    let active = true;

    userSearch(query)
      .then((res) => {
        if (active) setResult(res.data || []);
      })
      .catch((error) => {
        console.error("User search error:", error);
        if (active) setResult([]);
      });

    return () => {
      active = false;
    };
  }, [debouncedSearch]);

  const clearSearch = () => {
    setSearch("");
    setResult([]);
  };

  const closeSearch = () => {
    clearSearch();
    if (searchToggle) setSearchToggle(false);
  };

  return (
    <div className="relative flex w-full">
      {/* SEARCH INPUT */}

      <div className="flex w-full items-center gap-2 rounded-full border border-gray-200 bg-gray-50 px-3 py-2 shadow-sm transition focus-within:border-purple-300 focus-within:ring-2 focus-within:ring-purple-500/20">
        <IoMdSearch size={20} className="shrink-0 text-gray-400" />

        <input type="text" onChange={(e) => setSearch(e.target.value)} placeholder="Search users..." value={search} className="min-w-0 flex-1 bg-transparent text-sm text-gray-700 outline-none placeholder:text-gray-400" />

        {search && (
          <button type="button" onClick={closeSearch} className="flex shrink-0 items-center justify-center text-gray-400 transition hover:text-gray-600" aria-label="Clear search">
            <AiFillCloseCircle size={18} />
          </button>
        )}
      </div>

      {/* RESULTS */}

      {result.length > 0 && (
        <div className="absolute left-0 right-0 top-[calc(100%+8px)] z-50 max-h-64 overflow-y-auto rounded-xl border border-gray-100 bg-white py-1 shadow-xl">
          {result.map((people) => (
            <Link key={people?.id} to={`/profile/${people?.id}`} onClick={clearSearch} className="flex items-center gap-3 px-3 py-2.5 transition hover:bg-gray-50">
              {/* AVATAR — 1:1 */}

              <img src={getMediaUrl(people?.profile_img)} className="h-9 w-9 shrink-0 rounded-full border border-gray-200 object-cover" alt={`${people?.firstname || ""} ${people?.lastname || ""}`} />

              <span className="min-w-0 truncate text-sm font-medium text-gray-700">
                {people?.firstname} {people?.lastname}
              </span>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default UserSearch;